import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface PageSectionProps {
  $subNavigation?: boolean;
}

export const PageSection = styled.div<PageSectionProps>`
  --page-section-spacing: ${size(2)};

  ${(props) => props.theme.breakpoint.Md} {
    --page-section-spacing: ${size(7)};
  }

  & + & {
    margin-top: var(--page-section-spacing);
  }

  // Place closer to PageHeader if contains sub navigation
  ${({ $subNavigation }) =>
    $subNavigation &&
    css`
      ${(props) => props.theme.breakpoint.Md} {
        margin-top: calc((var(--page-section-spacing) * -1) + ${size(4)});
      }
    `}
`;
